import { createI18n } from "vue-i18n";


const messages = {
  grouprev_en: {
    fundraiser: "campaign | campaigns",
    Fundraiser: "Campaign | Campaigns",
    fundraiser_page: "Fundraiser | Fundraisers",
    donation: "donation | donations",
    nav: {
      home: "Home",
      about: "About"
    },
    home: {
      header: "Welcome to the Vue 3 I18n tutorial!",
      created_by: "This tutorial was brought to you by Lokalise."
    },
    about: {
      header: "About us"
    }
  }
}

export default createI18n({
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  legacy: true,
  globalInjection: true,
  messages: messages
})

